import jsCookie from 'js-cookie';
import { CookieNotAvailableError } from '../errors';
import { console } from './console';
import { extractedRootDomain } from './metadata';

const AVAILABLE_CHECK_COOKIE_KEY = 'rpr_cookie_available_check';
const DEFAULT_COOKIE_OPTIONS: jsCookie.CookieAttributes = {
  domain: extractedRootDomain,
  sameSite: 'lax',
};

export const cookie = {
  get: (key?: any) => jsCookie.get(key),
  getJSON: (key?: any) => jsCookie.getJSON(key),
  set: (key: string, value: any, options?: jsCookie.CookieAttributes) => {
    const cookieOptions = { ...DEFAULT_COOKIE_OPTIONS, ...options };
    if (cookieOptions.domain == null) {
      cookieOptions.domain = extractedRootDomain;
    }
    jsCookie.set(key, value, cookieOptions);
    if (jsCookie.get(key) !== (typeof value === 'string' ? value : JSON.stringify(value))) {
      console.error(new CookieNotAvailableError('Cookie is not available'));
    }
  },
  remove: (key: string, options?: jsCookie.CookieAttributes) => {
    const cookieOptions = { ...DEFAULT_COOKIE_OPTIONS, ...options };
    if (cookieOptions.domain == null) {
      cookieOptions.domain = extractedRootDomain;
    }
    jsCookie.remove(key, cookieOptions);
  },
  removeReproEntries: (options?: jsCookie.CookieAttributes) => {
    const storedCookieKeys = Object.keys(jsCookie.get()).filter((k) => k.match(/^rpr_/));
    storedCookieKeys.forEach((key) => cookie.remove(key, options));
  },
  get isAvailable() {
    jsCookie.set(AVAILABLE_CHECK_COOKIE_KEY, 'test', DEFAULT_COOKIE_OPTIONS);
    if (jsCookie.get(AVAILABLE_CHECK_COOKIE_KEY) === 'test') {
      jsCookie.remove(AVAILABLE_CHECK_COOKIE_KEY, DEFAULT_COOKIE_OPTIONS);
      return true;
    }
    jsCookie.remove(AVAILABLE_CHECK_COOKIE_KEY, DEFAULT_COOKIE_OPTIONS);
    return false;
  },
};
